import * as React from 'react';
import { ImageAttachment as ImageAttachmentT } from '../../../typedefs/store';
import styled from 'styled-components';

interface Props {
    attachment: ImageAttachmentT;
}

interface State {}

class ImageAttachment extends React.Component<Props, State> {
    viewImage = () => {
        if (this.props.attachment.url) window.open(this.props.attachment.url, 'new');
    };

    render() {
        return (
            <Wrapper className="conversations-attachment conversations-attachment-image" onClick={this.viewImage}>
                <Image src={this.props.attachment.url} />
            </Wrapper>
        );
    }
}

export default ImageAttachment;

const Wrapper = styled.div`cursor: pointer;`;

const Image = styled.img`max-width: 100%;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/ImageAttachment.tsx